import { interpolate, printf, toText } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { Record, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { float64_type, obj_type, record_type, string_type, array_type, option_type, union_type, int32_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { GroupHistoryEntry_$reflection, EconomyTypedEntry_$reflection, EconomyTypeSpread_$reflection, CustomerInfo_$reflection } from "./Shared/ApiDataTypes.js";
import { Orders_OrderType_FromId_Z524259A4, Economy_defaultMinYear, Orders_OrderType_get_AllCases, Orders_OrderType__ToLocalizedString_12C6553D, Orders_OrderType__get_Id, Orders_OrderType, Option_catch, Orders_OrderType_$reflection } from "./Shared/Shared.js";
import { FetchError, FetchError_$reflection } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { some, unwrap, map, bind, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { parse } from "./fable_modules/fable-library-js.4.24.0/Int32.js";
import { setQuery, useResponsive, toAbbrMonth, formatMoney, getQuery } from "./Utils.js";
import { now, year as year_5 } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { API_History_GroupHistory, API_Economy_MachineEconomyTotal, API_Economy_GroupEconomyTotal, API_Economy_CustomerEconomyTotal, API_Economy_MachineSpreadYear, API_Economy_GroupSpreadYear, API_Economy_CustomerSpreadYear, API_Economy_MachineEconomyYear, API_Economy_GroupEconomyYear, API_Economy_CustomerEconomyYear } from "./Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { testRedirect, extraCoders } from "./Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton, cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { comparePrimitives, int32ToString, compareArrays, createObj, equals, uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reverse, sortByDescending, collect, sumBy, sortBy, map as map_1 } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { getColor } from "./Orders/Orders.js";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Checkbox, FormControlLabel, Skeleton, Autocomplete, MenuItem, TextField, TableFooter, TableBody, TableRow, TableHead, Table, TableCell, Typography } from "@mui/material";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { BarChart, Bar, YAxis, XAxis, ResponsiveContainer, PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
import { ctx as ctx_1 } from "./Context.js";
import { Colors_AlertsPositiveDark, Colors_LightBlue } from "./Design.js";
import { objectHas } from "./fable_modules/Feliz.Recharts.4.2.0/Interop.fs.js";
import { toArray, empty as empty_1, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { SnackError, skeletonRows } from "./ViewHelpers.js";
import { hierarchyContext } from "./CompanyHierarchyContext.js";
import { rangeDouble } from "./fable_modules/fable-library-js.4.24.0/Range.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { CustomerHistory } from "./Customer/CustomerHistory.js";
import Info from "@mui/icons-material/Info";
import { MachineHistory } from "./Machine/MachineHistory.js";

export class Target extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Machine", "Customer", "Group"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? toText(printf("customer-%i"))(this$.fields[0]) : ((this$.tag === 2) ? toText(printf("group-%i"))(this$.fields[0]) : toText(printf("customer-%i-machine-%i"))(this$.fields[0])(this$.fields[1]));
    }
}

export function Target_$reflection() {
    return union_type("Kundeweb.Economy.Target", [], Target, () => [[["Item1", int32_type], ["Item2", int32_type]], [["Item", int32_type]], [["Item", int32_type]]]);
}

class Model extends Record {
    constructor(Target, SelectedYear, SelectedCustomer, OrderType, YearSpread, YearEntries, TotalEntries, ErrorMsg) {
        super();
        this.Target = Target;
        this.SelectedYear = (SelectedYear | 0);
        this.SelectedCustomer = SelectedCustomer;
        this.OrderType = OrderType;
        this.YearSpread = YearSpread;
        this.YearEntries = YearEntries;
        this.TotalEntries = TotalEntries;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.Economy.Model", [], Model, () => [["Target", Target_$reflection()], ["SelectedYear", int32_type], ["SelectedCustomer", option_type(CustomerInfo_$reflection())], ["OrderType", Orders_OrderType_$reflection()], ["YearSpread", option_type(EconomyTypeSpread_$reflection())], ["YearEntries", option_type(array_type(EconomyTypedEntry_$reflection()))], ["TotalEntries", option_type(array_type(EconomyTypedEntry_$reflection()))], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DismissError", "SelectCustomer", "SelectOrderType", "SelectYear", "SetSpread", "SetTotal", "SetYearly", "TotalResponse", "YearResponse", "YearSpreadResponse"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.Economy.Message", [], Message, () => [[], [["Item", option_type(CustomerInfo_$reflection())]], [["Item", Orders_OrderType_$reflection()]], [["Item", int32_type]], [["Item", option_type(EconomyTypeSpread_$reflection())]], [["Item", option_type(array_type(EconomyTypedEntry_$reflection()))]], [["Item", option_type(array_type(EconomyTypedEntry_$reflection()))]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(EconomyTypedEntry_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(EconomyTypedEntry_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(EconomyTypedEntry_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(EconomyTypedEntry_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [EconomyTypeSpread_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", EconomyTypeSpread_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]]]);
}

function init(target) {
    return new Model(target, defaultArg(bind((x) => Option_catch((value) => parse(value, 511, false, 32), x), getQuery("year")), year_5(now())), undefined, new Orders_OrderType(0, []), undefined, undefined, undefined, undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 2:
            return new Model(model.Target, model.SelectedYear, model.SelectedCustomer, msg.fields[0], model.YearSpread, model.YearEntries, model.TotalEntries, model.ErrorMsg);
        case 1:
            return new Model(model.Target, model.SelectedYear, msg.fields[0], model.OrderType, model.YearSpread, model.YearEntries, model.TotalEntries, model.ErrorMsg);
        case 3:
            return new Model(model.Target, msg.fields[0], model.SelectedCustomer, model.OrderType, model.YearSpread, (msg.fields[0] !== model.SelectedYear) ? undefined : model.YearEntries, model.TotalEntries, model.ErrorMsg);
        case 4:
            return new Model(model.Target, model.SelectedYear, model.SelectedCustomer, model.OrderType, msg.fields[0], model.YearEntries, model.TotalEntries, model.ErrorMsg);
        case 5:
            return new Model(model.Target, model.SelectedYear, model.SelectedCustomer, model.OrderType, model.YearSpread, model.YearEntries, msg.fields[0], model.ErrorMsg);
        case 6:
            return new Model(model.Target, model.SelectedYear, model.SelectedCustomer, model.OrderType, model.YearSpread, msg.fields[0], model.TotalEntries, model.ErrorMsg);
        case 7:
            if (msg.fields[0].tag === 1) {
                return new Model(model.Target, model.SelectedYear, model.SelectedCustomer, model.OrderType, model.YearSpread, model.YearEntries, model.TotalEntries, "Kunne ikke laste rapport for alle år. Vennligst prøv igjen senere.");
            }
            else {
                return new Model(model.Target, model.SelectedYear, model.SelectedCustomer, model.OrderType, model.YearSpread, model.YearEntries, msg.fields[0].fields[0], model.ErrorMsg);
            }
        case 8:
            if (msg.fields[0].tag === 1) {
                return new Model(model.Target, model.SelectedYear, model.SelectedCustomer, model.OrderType, model.YearSpread, model.YearEntries, model.TotalEntries, "Kunne ikke laste rapport. Vennligst prøv igjen senere.");
            }
            else {
                return new Model(model.Target, model.SelectedYear, model.SelectedCustomer, model.OrderType, model.YearSpread, msg.fields[0].fields[0], model.TotalEntries, model.ErrorMsg);
            }
        case 9:
            if (msg.fields[0].tag === 1) {
                return new Model(model.Target, model.SelectedYear, model.SelectedCustomer, model.OrderType, model.YearSpread, model.YearEntries, model.TotalEntries, "Kunne ikke laste kostnadsfordeling. Vennligst prøv igjen senere.");
            }
            else {
                return new Model(model.Target, model.SelectedYear, model.SelectedCustomer, model.OrderType, msg.fields[0].fields[0], model.YearEntries, model.TotalEntries, model.ErrorMsg);
            }
        default:
            return new Model(model.Target, model.SelectedYear, model.SelectedCustomer, model.OrderType, model.YearSpread, model.YearEntries, model.TotalEntries, undefined);
    }
}

function fetchEconomyForYear(year, orderType, customerOpt, target) {
    let properties_2;
    const ot_1 = (orderType.tag === 0) ? undefined : Orders_OrderType__get_Id(orderType);
    const customerIdOpt = map((_arg) => _arg.Id, customerOpt);
    const url = (target.tag === 1) ? API_Economy_CustomerEconomyYear(target.fields[0], year, ot_1) : ((target.tag === 2) ? API_Economy_GroupEconomyYear(year, ot_1, customerIdOpt, target.fields[0]) : API_Economy_MachineEconomyYear(target.fields[0], target.fields[1], year, ot_1));
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(EconomyTypedEntry_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg_1) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(EconomyTypedEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

function fetchSpreadForYear(year, customerOpt, target) {
    let properties_2;
    const url = (target.tag === 1) ? API_Economy_CustomerSpreadYear(target.fields[0], year) : ((target.tag === 2) ? API_Economy_GroupSpreadYear(year, map((_arg) => _arg.Id, customerOpt), target.fields[0]) : API_Economy_MachineSpreadYear(year, target.fields[0], target.fields[1]));
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(EconomyTypeSpread_$reflection(), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg_1) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(EconomyTypeSpread_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

function fetchEconomyTotal(fromYear, orderType, customerOpt, target) {
    let properties_2;
    const thisYear = year_5(now()) | 0;
    const ot_1 = (orderType.tag === 0) ? undefined : Orders_OrderType__get_Id(orderType);
    const customerIdOpt = map((_arg) => _arg.Id, customerOpt);
    const url = (target.tag === 1) ? API_Economy_CustomerEconomyTotal(target.fields[0], fromYear, thisYear, ot_1) : ((target.tag === 2) ? API_Economy_GroupEconomyTotal(fromYear, thisYear, ot_1, customerIdOpt, target.fields[0]) : API_Economy_MachineEconomyTotal(target.fields[0], target.fields[1], fromYear, thisYear, ot_1));
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(EconomyTypedEntry_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg_1) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(EconomyTypedEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

class Point extends Record {
    constructor(Name, Amount) {
        super();
        this.Name = Name;
        this.Amount = Amount;
    }
}

function Point_$reflection() {
    return record_type("Kundeweb.Economy.Point", [], Point, () => [["Name", string_type], ["Amount", float64_type]]);
}

class TypedOrderEntry extends Record {
    constructor(Name, Service, Sales, Project, Other) {
        super();
        this.Name = Name;
        this.Service = Service;
        this.Sales = Sales;
        this.Project = Project;
        this.Other = Other;
    }
}

function TypedOrderEntry_$reflection() {
    return record_type("Kundeweb.Economy.TypedOrderEntry", [], TypedOrderEntry, () => [["Name", string_type], ["Service", float64_type], ["Sales", float64_type], ["Project", float64_type], ["Other", float64_type]]);
}

function custom(key, value) {
    return [key, value];
}

function moneyTick(lang, value) {
    return formatMoney(lang, value);
}

class OrderData extends Record {
    constructor(Type, Color, Label, Amount) {
        super();
        this.Type = Type;
        this.Color = Color;
        this.Label = Label;
        this.Amount = Amount;
    }
}

function OrderData_$reflection() {
    return record_type("Kundeweb.Economy.OrderData", [], OrderData, () => [["Type", Orders_OrderType_$reflection()], ["Color", string_type], ["Label", string_type], ["Amount", float64_type]]);
}

function getAmount(spread, orderType) {
    switch (orderType.tag) {
        case 2:
            return spread.Sale;
        case 3:
            return spread.Project;
        case 0:
        case 4:
            return spread.Other;
        default:
            return spread.Service;
    }
}

function getLabel(lang, locale, orderType) {
    switch (orderType.tag) {
        case 1:
        case 2:
        case 3:
            return Orders_OrderType__ToLocalizedString_12C6553D(orderType, lang);
        default:
            return locale.t("Other");
    }
}

function YearSpreadPieChart(yearSpreadPieChartInputProps) {
    let array, elems_5, properties_14, properties_13, elements_1, properties_12, elements;
    const spread = yearSpreadPieChartInputProps.spread;
    const selectedOrderType = yearSpreadPieChartInputProps.selectedOrderType;
    const year = yearSpreadPieChartInputProps.year;
    const locale = yearSpreadPieChartInputProps.locale;
    const lang = yearSpreadPieChartInputProps.lang;
    const entries = map_1((orderType) => (new OrderData(orderType, getColor(orderType), getLabel(lang, locale, orderType), getAmount(spread, orderType))), (array = Orders_OrderType_get_AllCases(), array.filter((case$) => {
        if (!equals(case$, new Orders_OrderType(4, []))) {
            if (equals(selectedOrderType, new Orders_OrderType(0, []))) {
                return true;
            }
            else {
                return equals(selectedOrderType, case$);
            }
        }
        else {
            return false;
        }
    })));
    const legends = map_1((entry_1) => {
        let elems_1, elems;
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 10 + "px",
            padding: 5 + "px",
        }], (elems_1 = [createElement("div", {
            style: {
                width: 5,
                height: 40,
                backgroundColor: entry_1.Color,
            },
        }), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = [createElement("span", {
            children: [entry_1.Label],
        }), createElement("span", {
            style: {
                fontSize: 0.8 + "rem",
            },
            children: formatMoney(lang, entry_1.Amount),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }, entries);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexBasis: 600 + "px",
        padding: 20 + "px",
        gap: 20 + "px",
        borderRadius: 15 + "px",
        border: ((((1 + "px") + " ") + "solid") + " ") + "var(--grey)",
    }], (elems_5 = [MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", `${locale.t("Economy.OrderTypeSpread")} ${year}`]]), (properties_14 = ofArray([["minHeight", 300 + "px"], ["children", (properties_13 = ofArray([["width", 800], (elements_1 = singleton((properties_12 = ofArray([["data", entries], ["dataKey", (point) => point.Amount], ["nameKey", "order"], ["label", (test) => toText(interpolate("%0.2f%P()%%", [100 * test.percent]))], ["innerRadius", 40], (elements = ofArray([reactApi_1.createElement(Tooltip, {}), reactApi_1.createElement(Legend, {
        layout: "vertical",
        align: "right",
    }), map_1((entry) => reactApi_1.createElement(Cell, {
        key: entry.Label,
        stroke: "#fff",
        fill: entry.Color,
    }), entries)]), ["children", ["children", reactApi.Children.toArray(Array.from(elements))]])]), reactApi_1.createElement(Pie, createObj(properties_12)))), ["children", reactApi.Children.toArray(Array.from(elements_1))])]), reactApi_1.createElement(PieChart, createObj(properties_13)))]]), reactApi_1.createElement(ResponsiveContainer, createObj(properties_14))), createElement("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: 10 + "px",
        },
        children: reactApi.Children.toArray(Array.from(legends)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function DrawYearChart(drawYearChartInputProps) {
    let elems_1, properties_9, properties_8, elements, properties_2, properties_4, properties_5, properties_6, properties_7;
    const entries = drawYearChartInputProps.entries;
    const locale = drawYearChartInputProps.locale;
    const lang = drawYearChartInputProps.lang;
    const ctx = reactApi.useContext(ctx_1);
    const data = map_1((entry) => (new TypedOrderEntry(toAbbrMonth(lang, entry.Month), entry.ServiceAmount, entry.SalesAmount, entry.ProjectAmount, entry.OtherAmount)), sortBy((y) => [y.Year, y.Month], entries, {
        Compare: compareArrays,
    }));
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        flexBasis: 600 + "px",
        padding: 20 + "px",
        gap: 20 + "px",
        borderRadius: 15 + "px",
        border: ((((1 + "px") + " ") + "solid") + " ") + "var(--grey)",
    }], (elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", `${locale.t("Economy.PerMonthYear")} (eks. MVA)`]]), (properties_9 = ofArray([["minHeight", 300 + "px"], ["children", (properties_8 = ofArray([["margin", {
        top: defaultArg(undefined, 0),
        right: defaultArg(undefined, 0),
        left: defaultArg(75, 0),
        bottom: defaultArg(undefined, 0),
    }], ["data", data], (elements = ofArray([reactApi_1.createElement(XAxis, {
        dataKey: (point) => point.Name,
    }), (properties_2 = singleton(custom("tickFormatter", (value_26) => moneyTick(lang, value_26))), reactApi_1.createElement(YAxis, createObj(properties_2))), reactApi_1.createElement(Tooltip, {
        formatter: (delegateArg, delegateArg_1, delegateArg_2) => {
            const moneyStr = formatMoney(lang, delegateArg);
            return toText(printf("%s"))(moneyStr);
        },
    }), (properties_4 = ofArray([["stackId", "amount"], ["fill", "rgba(255, 205, 0, 1)"], ["name", ctx.Locale.t("Pages.Service")], ["dataKey", (point_1) => point_1.Service]]), reactApi_1.createElement(Bar, createObj(properties_4))), (properties_5 = ofArray([["stackId", "amount"], ["fill", Colors_LightBlue(1)], ["name", ctx.Locale.t("Economy.Sale")], ["dataKey", (point_2) => point_2.Sales]]), reactApi_1.createElement(Bar, createObj(properties_5))), (properties_6 = ofArray([["stackId", "amount"], ["fill", "rgba(91, 127, 149, 1)"], ["name", ctx.Locale.t("Economy.Project")], ["dataKey", (point_3) => point_3.Project]]), reactApi_1.createElement(Bar, createObj(properties_6))), (properties_7 = ofArray([["stackId", "amount"], ["fill", Colors_AlertsPositiveDark], ["name", ctx.Locale.t("Other")], ["dataKey", (point_4) => point_4.Other]]), reactApi_1.createElement(Bar, createObj(properties_7)))]), ["children", reactApi.Children.toArray(Array.from(elements))])]), reactApi_1.createElement(BarChart, createObj(properties_8)))]]), reactApi_1.createElement(ResponsiveContainer, createObj(properties_9)))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function DrawTotalChart(drawTotalChartInputProps) {
    let elems_1, properties_9, properties_8, elements, properties_2, properties_5;
    const entries = drawTotalChartInputProps.entries;
    const onClick = drawTotalChartInputProps.onClick;
    const locale = drawTotalChartInputProps.locale;
    const lang = drawTotalChartInputProps.lang;
    const data = map_1((y_2) => (new TypedOrderEntry(int32ToString(y_2.Year), y_2.ServiceAmount, y_2.SalesAmount, y_2.ProjectAmount, y_2.OtherAmount)), sortBy((y) => y.Year, entries, {
        Compare: comparePrimitives,
    }));
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px",
        flexBasis: 700 + "px",
        flexGrow: 2,
        padding: 20 + "px",
        borderRadius: 15 + "px",
        border: ((((1 + "px") + " ") + "solid") + " ") + "var(--grey)",
    }], (elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", `${locale.t("Economy.PerYear")} ${Economy_defaultMinYear} (eks. MVA)`]]), (properties_9 = ofArray([["minHeight", 300 + "px"], ["children", (properties_8 = ofArray([["data", data], ["margin", {
        top: defaultArg(undefined, 0),
        right: defaultArg(undefined, 0),
        left: defaultArg(75, 0),
        bottom: defaultArg(undefined, 0),
    }], ["onClick", (eventArgs) => {
        if ((eventArgs == null) ? true : objectHas(singleton("isTooltipActive"), eventArgs)) {
        }
        else {
            onClick(eventArgs.activeLabel);
        }
    }], (elements = ofArray([reactApi_1.createElement(XAxis, {
        dataKey: (point) => point.Name,
    }), (properties_2 = singleton(custom("tickFormatter", (value_28) => moneyTick(lang, value_28))), reactApi_1.createElement(YAxis, createObj(properties_2))), reactApi_1.createElement(Tooltip, {
        formatter: (delegateArg, delegateArg_1, delegateArg_2) => formatMoney(lang, delegateArg),
    }), reactApi_1.createElement(Bar, {
        stackId: "amount",
        fill: "rgba(255, 205, 0, 1)",
        name: "Service",
        dataKey: (point_1) => point_1.Service,
    }), (properties_5 = ofArray([["stackId", "amount"], ["fill", Colors_LightBlue(1)], ["name", "Salg"], ["dataKey", (point_2) => point_2.Sales]]), reactApi_1.createElement(Bar, createObj(properties_5))), reactApi_1.createElement(Bar, {
        stackId: "amount",
        fill: "rgba(91, 127, 149, 1)",
        name: "Prosjekt",
        dataKey: (point_3) => point_3.Project,
    }), reactApi_1.createElement(Bar, {
        stackId: "amount",
        fill: Colors_AlertsPositiveDark,
        name: "Andre",
        dataKey: (point_4) => point_4.Other,
    })]), ["children", reactApi.Children.toArray(Array.from(elements))])]), reactApi_1.createElement(BarChart, createObj(properties_8)))]]), reactApi_1.createElement(ResponsiveContainer, createObj(properties_9)))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function GroupCostTable(groupCostTableInputProps) {
    let elems_16, elems_7, elements_6, elems_15, elements_13;
    const groupId = groupCostTableInputProps.groupId;
    const customerOpt = groupCostTableInputProps.customerOpt;
    const year = groupCostTableInputProps.year;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const loading = patternInput[0];
    const patternInput_1 = reactApi.useState([]);
    const customerIdOpt = map((_arg) => _arg.Id, customerOpt);
    const filtered = patternInput_1[0].filter((group) => {
        if (customerIdOpt == null) {
            return true;
        }
        else {
            return equals(group.CustomerId, customerIdOpt);
        }
    });
    const sumStr = formatMoney(ctx.Language, sumBy((group_1) => group_1.Amount, filtered, {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    }));
    const machines = collect((entry) => map_1((machine) => [entry, machine], entry.Machines), filtered);
    const machineSumStr = formatMoney(ctx.Language, sumBy((tupledArg) => tupledArg[1].Amount, machines, {
        GetZero: () => 0,
        Add: (x_1, y_1) => (x_1 + y_1),
    }));
    const dependencies = [groupId, year];
    reactApi.useEffect(() => {
        let properties_2;
        const url = API_History_GroupHistory(groupId, year);
        setLoading(true);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(GroupHistoryEntry_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg_3) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg_3, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(GroupHistoryEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_4) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_4), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((res) => {
            if (res.tag === 0) {
                const entries_1 = res.fields[0];
                console.info(some("[Economy] Got history"), entries_1);
                patternInput_1[1](entries_1);
            }
            else {
                console.error(some("[Economy] Error fetching group history"), res.fields[0]);
            }
            setLoading(false);
        });
    }, dependencies);
    const th = (text) => MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", MuiHelpers_createElement(Typography, [["noWrap", true], ["variant", "h6"], ["children", text]])]]);
    const headerSum = (text_1) => MuiHelpers_createElement(TableCell, [["variant", "head"], ["align", "right"], ["children", MuiHelpers_createElement(Typography, [["noWrap", true], ["variant", "h6"], ["children", text_1]])]]);
    const cellText = (text_2) => MuiHelpers_createElement(TableCell, [["sx", {
        width: 60 + "ch",
    }], ["variant", "body"], ["children", text_2]]);
    const cellSum = (sum_2) => MuiHelpers_createElement(TableCell, [["sx", {
        width: 60 + "ch",
    }], ["align", "right"], ["variant", "body"], ["children", formatMoney(ctx.Language, sum_2)]]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 20 + "px",
    }], (elems_16 = [createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 800 + "px",
        maxWidth: 800 + "px",
    }], (elems_7 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("Companies.Companies")]]), MuiHelpers_createElement(Table, [(elements_6 = toList(delay(() => {
        let elements_1, elements;
        return append(singleton_1(MuiHelpers_createElement(TableHead, [(elements_1 = [MuiHelpers_createElement(TableRow, [(elements = [th(ctx.Locale.t("Company")), headerSum(ctx.Locale.t("Total"))], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])), delay(() => {
            let elements_3;
            return append(singleton_1(MuiHelpers_createElement(TableBody, [(elements_3 = (loading ? skeletonRows(2, 4) : map_1((group_3) => {
                let elements_2;
                return MuiHelpers_createElement(TableRow, [(elements_2 = [cellText(group_3.Customer), cellSum(group_3.Amount)], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
            }, sortByDescending((group_2) => group_2.Amount, filtered, {
                Compare: comparePrimitives,
            }))), ["children", reactApi.Children.toArray(Array.from(elements_3))])])), delay(() => {
                let elements_5, elements_4;
                return !loading ? singleton_1(MuiHelpers_createElement(TableFooter, [(elements_5 = [MuiHelpers_createElement(TableRow, [(elements_4 = [MuiHelpers_createElement(TableCell, [["colSpan", 1], ["variant", "footer"], ["children", MuiHelpers_createElement(Typography, [["children", "Total"]])]]), MuiHelpers_createElement(TableCell, [["align", "right"], ["variant", "footer"], ["children", MuiHelpers_createElement(Typography, [["children", sumStr]])]])], ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elements_5))])])) : empty_1();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elements_6))])])], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 1366 + "px",
        maxWidth: 1366 + "px",
    }], (elems_15 = [MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("Machine")]]), MuiHelpers_createElement(Table, [(elements_13 = toList(delay(() => {
        let elements_8, elements_7;
        return append(singleton_1(MuiHelpers_createElement(TableHead, [(elements_8 = [MuiHelpers_createElement(TableRow, [(elements_7 = [th(ctx.Locale.t("Company")), th(ctx.Locale.t("Machine")), headerSum(ctx.Locale.t("Total"))], ["children", reactApi.Children.toArray(Array.from(elements_7))])])], ["children", reactApi.Children.toArray(Array.from(elements_8))])])), delay(() => {
            let elements_10;
            return append(singleton_1(MuiHelpers_createElement(TableBody, [(elements_10 = (loading ? skeletonRows(3, 4) : map_1((tupledArg_2) => {
                let elements_9;
                const machine_3 = tupledArg_2[1];
                return MuiHelpers_createElement(TableRow, [(elements_9 = [cellText(tupledArg_2[0].Customer), cellText(machine_3.Machine), cellSum(machine_3.Amount)], ["children", reactApi.Children.toArray(Array.from(elements_9))])]);
            }, sortByDescending((tupledArg_1) => tupledArg_1[1].Amount, machines, {
                Compare: comparePrimitives,
            }))), ["children", reactApi.Children.toArray(Array.from(elements_10))])])), delay(() => {
                let elements_12, elements_11;
                return !loading ? singleton_1(MuiHelpers_createElement(TableFooter, [(elements_12 = [MuiHelpers_createElement(TableRow, [(elements_11 = [MuiHelpers_createElement(TableCell, [["colSpan", 2], ["variant", "footer"], ["children", MuiHelpers_createElement(Typography, [["children", "Total"]])]]), MuiHelpers_createElement(TableCell, [["align", "right"], ["variant", "footer"], ["children", MuiHelpers_createElement(Typography, [["children", machineSumStr]])]])], ["children", reactApi.Children.toArray(Array.from(elements_11))])])], ["children", reactApi.Children.toArray(Array.from(elements_12))])])) : empty_1();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elements_13))])])], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi.Children.toArray(Array.from(elems_16))])])));
}

export function View(viewInputProps) {
    let elems_4, elems_7;
    const target = viewInputProps.target;
    const key = viewInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const companyHierarchy = reactApi.useContext(hierarchyContext);
    const responsive = useResponsive(undefined);
    let patternInput;
    const arg_1 = init(target);
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const companies = collect((group) => {
        let matchResult, id_1;
        if (target.tag === 2) {
            if (target.fields[0] === group.Id) {
                matchResult = 0;
                id_1 = target.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return group.Customers;
            default:
                return [];
        }
    }, companyHierarchy.Groups);
    const dependencies = [target, model_1.SelectedYear, model_1.SelectedCustomer];
    reactApi.useEffect(() => {
        const pr = fetchSpreadForYear(model_1.SelectedYear, model_1.SelectedCustomer, target);
        pr.then((arg_2) => {
            dispatch(new Message(9, [arg_2]));
        });
    }, dependencies);
    const dependencies_2 = [target, model_1.SelectedYear, model_1.SelectedCustomer, model_1.OrderType];
    reactApi.useEffect(() => {
        const pr_1 = fetchEconomyForYear(model_1.SelectedYear, model_1.OrderType, model_1.SelectedCustomer, target);
        pr_1.then((arg_3) => {
            dispatch(new Message(8, [arg_3]));
        });
    }, dependencies_2);
    const dependencies_4 = [target, model_1.SelectedCustomer, model_1.OrderType];
    reactApi.useEffect(() => {
        const pr_2 = fetchEconomyTotal(Economy_defaultMinYear, model_1.OrderType, model_1.SelectedCustomer, target);
        pr_2.then((arg_4) => {
            dispatch(new Message(7, [arg_4]));
        });
    }, dependencies_4);
    const xs_7 = [createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(0, []));
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px",
    }], (elems_4 = toList(delay(() => {
        let elems_2;
        return append(singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            columnGap: 15 + "px",
            padding: 10 + "px",
            backgroundColor: "white",
        }], (elems_2 = toList(delay(() => {
            let elems;
            return append(singleton_1(MuiHelpers_createElement(TextField, [["id", "year-select"], ["label", ctx.Locale.t("History.Year")], ["size", "small"], ["sx", {
                minWidth: 25 + "ch",
            }], ["select", true], ["value", model_1.SelectedYear], ["onChange", (ev) => {
                const year_3 = ev.target.value | 0;
                setQuery("year", int32ToString(year_3));
                dispatch(new Message(3, [year_3]));
            }], (elems = [map_1((y) => MuiHelpers_createElement(MenuItem, [["value", y], ["children", y]]), reverse(toArray(rangeDouble(Economy_defaultMinYear, 1, year_5(now())))))], ["children", reactApi.Children.toArray(Array.from(elems))])])), delay(() => {
                let matchValue;
                return append((matchValue = target, (matchValue.tag === 1) ? singleton_1(defaultOf()) : ((matchValue.tag === 2) ? singleton_1(MuiHelpers_createElement(Autocomplete, [["id", "group-company-select"], ["sx", {
                    minWidth: 25 + "ch",
                }], ["size", "small"], ["onChange", (delegateArg, delegateArg_1, delegateArg_2) => {
                    dispatch(new Message(1, [delegateArg_1]));
                }], ["options", Array.from(companies)], ["getOptionLabel", (customer) => customer.Name], ["renderInput", (parameters) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(parameters), delay(() => singleton_1(["label", "Selskap"]))))))]])) : singleton_1(defaultOf()))), delay(() => {
                    let elems_1;
                    return singleton_1(MuiHelpers_createElement(TextField, [["id", "order-type-select"], ["label", ctx.Locale.t("Economy.OrderType")], ["size", "small"], ["sx", {
                        minWidth: 25 + "ch",
                    }], ["select", true], ["value", Orders_OrderType__get_Id(model_1.OrderType)], ["onChange", (ev_1) => {
                        dispatch(new Message(2, [Orders_OrderType_FromId_Z524259A4(ev_1.target.value)]));
                    }], (elems_1 = map_1((ot_1) => MuiHelpers_createElement(MenuItem, [["value", Orders_OrderType__get_Id(ot_1)], ["children", Orders_OrderType__ToLocalizedString_12C6553D(ot_1, ctx.Language)]]), [new Orders_OrderType(0, []), new Orders_OrderType(1, []), new Orders_OrderType(2, []), new Orders_OrderType(3, [])]), ["children", reactApi.Children.toArray(Array.from(elems_1))])]));
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            const matchValue_1 = responsive;
            switch (matchValue_1) {
                case "wideScreen":
                    return append(singleton_1(MuiHelpers_createElement(Typography, [["variant", "h3"], ["children", ctx.Locale.t("Economy.FinancialStatistics")]])), delay(() => {
                        let elems_3;
                        return singleton_1(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexWrap: "nowrap",
                            width: 100 + "%",
                            gap: 30 + "px",
                        }], (elems_3 = toList(delay(() => {
                            let matchValue_2, spread_1;
                            return append((matchValue_2 = model_1.YearSpread, (matchValue_2 == null) ? singleton_1(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
                                width: 100 + "%",
                                minHeight: 90,
                            }]])) : singleton_1((spread_1 = matchValue_2, createElement(YearSpreadPieChart, {
                                lang: ctx.Language,
                                locale: ctx.Locale,
                                year: model_1.SelectedYear,
                                selectedOrderType: model_1.OrderType,
                                spread: spread_1,
                            })))), delay(() => {
                                let matchValue_3, entries_1;
                                return append((matchValue_3 = model_1.YearEntries, (matchValue_3 == null) ? singleton_1(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
                                    width: 100 + "%",
                                    maxWidth: 800,
                                    minHeight: 300,
                                }]])) : singleton_1((entries_1 = matchValue_3, createElement(DrawYearChart, {
                                    lang: ctx.Language,
                                    locale: ctx.Locale,
                                    entries: entries_1,
                                })))), delay(() => {
                                    let entries_3;
                                    const matchValue_4 = model_1.TotalEntries;
                                    return (matchValue_4 == null) ? singleton_1(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
                                        width: 100 + "%",
                                        maxWidth: 800,
                                        minHeight: 360,
                                    }]])) : singleton_1((entries_3 = matchValue_4, createElement(DrawTotalChart, {
                                        lang: ctx.Language,
                                        locale: ctx.Locale,
                                        onClick: (yearStr) => {
                                            let year;
                                            try {
                                                year = parse(yearStr, 511, false, 32);
                                            }
                                            catch (e) {
                                                console.error(some("Exception turning str %s to int: %s"), yearStr, e.message);
                                                year = year_5(now());
                                            }
                                            setQuery("year", int32ToString(year));
                                            dispatch(new Message(3, [year]));
                                        },
                                        entries: entries_3,
                                    })));
                                }));
                            }));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                    }));
                default:
                    return singleton_1(defaultOf());
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px",
    }], (elems_7 = toList(delay(() => {
        let elems_5;
        return (target.tag === 1) ? append(singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 20 + "px",
        }], (elems_5 = [MuiHelpers_createElement(Typography, [["id", "invoice-overview"], ["variant", "h3"], ["children", ctx.Locale.t("Economy.InvoiceOverview")]]), MuiHelpers_createElement(FormControlLabel, [["style", {
            display: "none",
        }], ["label", ctx.Locale.t("Economy.HideEmpty")], ["checked", patternInput_1[0]], ["onChange", (e_1) => {
            patternInput_1[1](e_1.target.checked);
        }], ["control", MuiHelpers_createElement(Checkbox, [])]])], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => singleton_1(createElement(CustomerHistory, {
            year: model_1.SelectedYear,
            orderType: model_1.OrderType,
            customerId: target.fields[0],
        })))) : ((target.tag === 2) ? append(singleton_1(MuiHelpers_createElement(Typography, [["id", "customer-group-costs-table"], ["variant", "h3"], ["children", ctx.Locale.t("Economy.Costs")]])), delay(() => {
            let elems_6, props_20;
            return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 15 + "px",
            }], (elems_6 = [(props_20 = {}, react.createElement(Info, props_20)), MuiHelpers_createElement(Typography, [["variant", "subtitle2"], ["children", ctx.Locale.t("Economy.OrderTable")]])], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => singleton_1(createElement("div", {
                style: {
                    padding: 20 + "px",
                    borderRadius: 15 + "px",
                },
                children: createElement(GroupCostTable, {
                    year: model_1.SelectedYear,
                    customerOpt: unwrap(model_1.SelectedCustomer),
                    groupId: target.fields[0],
                }),
            }))));
        })) : append(singleton_1(MuiHelpers_createElement(Typography, [["id", "invoice-overview"], ["variant", "h3"], ["children", ctx.Locale.t("Economy.InvoiceOverview")]])), delay(() => singleton_1(createElement(MachineHistory, {
            year: model_1.SelectedYear,
            orderType: model_1.OrderType,
            customerId: target.fields[0],
            machineId: target.fields[1],
        })))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))];
    return react.createElement(react.Fragment, {}, ...xs_7);
}

